// #@flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description =
  "This application allows creating polls and shows predictions of upcoming selected matches.";

const CONFIG: InteractivesMenuItemConfig = {
  name: "Match Predictor",
  id: "match-predictor",
  linkPrefix: "/interactives",
  tags: ["Sports", "Match", "Afl", "Nrl"],
  groupsWithAccess: ["admin_user", "specialist_user"],
  description,
  image: DisplayImage,
  adminOnly: false,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/match-predictor/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import("app/components/tools/MatchPredictorConfigTool/MatchPredictorConfigTool"),
    loading: DynamicImportLoader,
    modules: ["MatchPredictorConfigTool"]
  })
};

export default CONFIG;
